import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { isTirageNotYetAvailable } from "./tirageArticleQuery";
import { toLocalYmd } from "./localDate";
import { getTirageAnalyse, TirageAnalyseOutput } from "../endpoints/public/tirage-analyse_GET.schema";

export const TIRAGE_ANALYSE_QUERY_KEY = "tirage-analyse";

interface UseTirageAnalyseOptions {
  date: string;
  startDate?: Date;
  endDate?: Date;
}

export function useTirageAnalyse(options: UseTirageAnalyseOptions | string) {
  const { date, startDate, endDate } = typeof options === 'string'
    ? { date: options, startDate: undefined, endDate: undefined }
    : options;

  const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(date);

  // Skip le fetch quand on sait que le tirage n'est pas encore en DB :
  // - date strictement future
  // - date = aujourd'hui ET il est avant 20h (le scrape FDJ populate dès 20:05)
  // Évite un 404 inutile dans la console + économise un round-trip réseau.
  // Le fallback teaser (TirageTeaserView) s'affiche directement.
  const isFutureDate = isValidDate && isTirageNotYetAvailable(date);

  const startDateStr = startDate ? toLocalYmd(startDate) : undefined;
  const endDateStr = endDate ? toLocalYmd(endDate) : undefined;

  return useQuery<TirageAnalyseOutput | null>({
    queryKey: [TIRAGE_ANALYSE_QUERY_KEY, date, startDateStr, endDateStr],
    queryFn: () => getTirageAnalyse({
      date,
      startDate: startDateStr,
      endDate: endDateStr,
    }),
    enabled: isValidDate && !isFutureDate,
    placeholderData: keepPreviousData,
    // API tirage-analyse uses Cache-Control: no-store; admin still invalidates after IA edits.
    staleTime: 1000 * 60 * 30,
  });
}
